const ENTITY_LINK_PATTERNS = [
  {
    entityType: "OPPORTUNITY",
    pattern: /^#\/capture\/(?:tracked|archived)-opportunities\/(\d+)/,
  },
  {
    entityType: "PROPOSAL",
    pattern: /^#\/proposals\/(?:view|archived)\/(\d+)/,
  },
  { entityType: "CONTRACT", pattern: /^#\/contracts\/(?:all|archived)\/(\d+)/ },
  {
    entityType: "MISC_ANALYSIS",
    pattern: /^#\/misc-analysis\/(?:view|archived)\/(\d+)/,
  },
];

export const resolveEntityLink = (hash) => {
  for (const { entityType, pattern } of ENTITY_LINK_PATTERNS) {
    const match = hash?.match(pattern);
    if (match) {
      return { entityType, entityId: match[1] };
    }
  }
  return null;
};
